// import { take, call, put, select, takeLatest } from 'redux-saga/effects';
// import { acapellasActions as actions } from '.';

// function* doSomething() {}
import {Api} from "../../../../store/api";
import {all, put, select, takeEvery, takeLatest} from "redux-saga/effects";
import {acapellasActions} from "app/pages/AcapellasPage/slice";
import {voiceModelActions} from "app/pages/VoiceModelsPage/slice";
import {selectSelectedPreviewVoice} from "app/pages/VoiceModelsPage/slice/selectors";
import {selectQuery} from "app/pages/AcapellasPage/slice/selectors";

function* fetchAcapellas(action) {
    try {
        console.log("fetchAcapellaSaga");
        const voice_model_uuid = action.payload?.voice?.uuid || null
        const acapellas = yield Api.fetchAcapellas(voice_model_uuid);
        const actionPayload = { acapellas: acapellas.data }
        yield put({type: acapellasActions.updateAcapellas.type, payload: actionPayload});
    } catch (e) {
        yield put({type: acapellasActions.fetchAcapellasError.type, payload: e});
    }
}
function* searchSongs() {
    try {
        console.log("searchSongSaga");
        // Get previewVoice from voiceModels redux store
        const previewVoice = yield select(selectSelectedPreviewVoice)
        // Get query from state (this allows us to retrigger search from components that don't have to access to the query)
        const query = yield select(selectQuery)
        const songs = yield Api.searchCatalog(query, previewVoice?.uuid || null);
        const actionPayload = { songs: songs.data.catalog }
        yield put({type: acapellasActions.updateSongs.type, payload: actionPayload});
    } catch (e) {
        yield put({type: acapellasActions.fetchAcapellasError.type, payload: e});
    }
}

// Acapellas saga
export default function* acapellasSaga() {
    // if necessary, start multiple sagas at once with `all`
    yield all([
        takeLatest(acapellasActions.fetchAcapellas.type, fetchAcapellas),
        takeLatest(acapellasActions.searchSongs.type, searchSongs),
        takeLatest(voiceModelActions.setSelectedPreviewVoice.type, searchSongs),
    ]);
}